module.exports = __webpack_public_path__ + "static/Testhero-54453cd2d4e96e9d70559499f9262c40.png";